package com.milta.feature.admin.domain.usecase

import com.milta.feature.admin.domain.entity.AdminClaudeUsage
import com.milta.feature.admin.domain.entity.AdminClaudeUsagePeriod
import com.milta.feature.admin.domain.repository.AdminRepository

class GetAdminClaudeUsageUseCase(private val repository: AdminRepository) {
    suspend operator fun invoke(period: AdminClaudeUsagePeriod): Result<AdminClaudeUsage> =
        repository.getClaudeUsage(period)
}
